// ===================================================================
// AdminSupportSection
// ===================================================================
// Embebe el AdminSupportPanel dentro del AdminPanel principal en modo
// `embedded`: sin doble portal y sin overlay propio (el AdminPanel ya
// es overlay). Antes hacía createPortal anidado y el panel quedaba
// detrás del AdminPanel — invisible —, dejando la sección en blanco.
// ===================================================================

import React from 'react';
import AdminSupportPanel from '../../Support/AdminSupportPanel';

export default function AdminSupportSection({ currentUser }) {
    return (
        <AdminSupportPanel
            currentUser={currentUser}
            embedded
        />
    );
}
